import React, { useRef, useState, useEffect } from "react";

import "../styles/InvestorRelay.css";
import Footer from '../component/footer';

const InvestorRelay = () => {
    return (
        <div className="investor_page">
            <div className="investor-banner">
                <h1> Investor Relations </h1>
            </div>

            <div className="investor-content">
                <iframe id="contentFrame" src="https://www.insage.com.my/ir/XOX/default.aspx" frameborder="0"></iframe>
            </div>

            <div style={{padding:"0px 5.208vw"}}>
                <Footer />
            </div>
        </div>
    )
}

export default InvestorRelay;